import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

import { AppConfig, CMPS_APP_CONFIG } from '../../../app.config';
import {
    catchErrorLogRet,
    mapRetrieve,
    mapUpdate,
} from '../../../common/rest.operators';

import { CaSummary } from './ca-summary.model';
import { CaResult } from './result/ca-result.model';

@Injectable()
export class ApiService {
    constructor(
        private readonly _http: HttpClient,
        @Inject(CMPS_APP_CONFIG) private readonly _appConfig: AppConfig,
    ) {}

    retrieveCaResult(meetingId: number): Observable<CaResult> {
        return this._http
            .get(
                `${this._appConfig.API_ENDPOINTS.COACHING}/meetings/${meetingId}/ca-result`,
            )
            .pipe(
                mapRetrieve(),
                tap((ret) => ret.value),
                catchErrorLogRet(null),
            );
    }

    retrieveCaSummary(transcriptId: number): Observable<CaSummary> {
        return this._http
            .get(
                `${this._appConfig.API_ENDPOINTS.COACHING}/transcripts/${transcriptId}/ca-summary`,
            )
            .pipe(
                mapRetrieve(),
                tap((ret) => ret.value),
                catchErrorLogRet(''),
            );
    }

    updateCaSummary(
        transcriptId: number,
        summary: string,
    ): Observable<boolean> {
        return this._http
            .put(
                `${this._appConfig.API_ENDPOINTS.COACHING}/transcripts/${transcriptId}/ca-summary`,
                { value: summary },
            )
            .pipe(mapUpdate(), catchErrorLogRet(false));
    }
}
